module.exports = __webpack_public_path__ + "static/media/nav-icon-survey-list-active.97d1a924.svg";